import React, { Component } from "react";
import {
  Progress,
  Nav,
  NavItem,
  NavLink
} from "reactstrap";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import Header from "../../Layout/Header/Header-loggedIn";
// import Footer from "../Footer/Footer";
import Hint from "../../Components/Hint/Hint";
import Group615 from "../../../Assets/img/Group 615.svg";
import Group648 from "../../../Assets/img/Group 648.svg";
import Group649 from "../../../Assets/img/Group 649.svg";
import Heart from "../../../Assets/img/Union 2.svg";
import ldr_brd_icon from "../../../Assets/img/ldr_brd_icon.svg"; 
// import FirstNotification from "../../../Assets/img/Group 2307.svg";
// import Close from "../../../Assets/img/Group 2324.svg";

import { make_request } from "../../Utils/Utils";
 import Timer from "react-compound-timer";

class LevelPageMobile extends Component {

  constructor(props){
    super(props);
    this.state = {
      progress_width:0,
      show: true,
      hint1: '',
      hint2: '',
      is_modal_open: false,
      hintPack: false,
      level: {},
      hints: {},
      skills: [],
      sponsors: [],
      completed_levels: [],
      show_this_hint: [],
      answer: '',
      leader_board: [],
      recent_answers: [],
      totalTimeInSec : 900,
      leftClassList : ['col-2'],
      rightClassList: ['card recent-answers mt-fix-10'],
      centerClassList: [],
      focus_sec : ['focus_grow'],
      hide_common : ['focus_hide'],
      align_timer : ['d-flex align-content-center top-area'],
      align_hint : ['top-area']
    }
    
    // let defaultSec = 0;
    // let timer = setInterval(() => {
    //   defaultSec = ( defaultSec + 1 );
    
    //   let finalSec = (( defaultSec / this.state.totalTimeInSec ) * 100 )  ;
    //   this.setState({progress_width: finalSec});
    // }, 1000);

    // if ( this.state.progress_width === 100 )
    // {
    //   clearInterval(this.timer);
    // }
  }

  toggleHint1 = () => {}
  toggleHint2 = () => {}
  toggleHint3 = () => {}
  toggleCart = () => {}
  toggleHintPack = () => {}

  toggle_modal = () => {
    this.setState({is_modal_open: !this.state.is_modal_open})
  };

  fetch_request = async () => {
    let responseJson = await make_request({
      path: 'get_level',
      method: 'GET'
    });
    if(!!responseJson){
      this.setState({
        level: responseJson["level"],
        hints: responseJson["hints"],
        skills: responseJson["skills"],
        sponsors: responseJson["sponsors"],
        completed_levels: responseJson["completed_levels"]
      });
    }
  }

  /*async componentDidMount(){
    if(authenticate()) {
      this.fetch_request();
    } else {
      this.props.history.push('/login');
    }
  }*/





  hint_track = () => {
    let i = 0;
    let show_this_hint = [];
    let hints_html_code = [];
    while(this.state.hints.count > i){
      if(this.state.hints.unlocked[i]){
        show_this_hint.push(this.state.hints.unlocked[i])
      }
      let current_hint = this.state.hints.unlocked[i];
      hints_html_code.push(
        <img
          key={i}
          src={(i+1 < this.state.hints.unlocked.length) ? Group648 : Group649}
          onClick={() => alert("Hint : "+current_hint)}
          className="icon1 group-img hand"
          alt="hint_image"
        />
      )
      i++;
    }
    return hints_html_code;
  }

  handle_change = (event) => {
    this.setState({[event.target.name]: event.target.value});
  }

  enter_pressed = (event) => {
    let code = event.keyCode || event.which;
    if(code === 13) {
      this.submit_answer();
    }
  }

  submit_answer = async () => {
    if(!!this.state.answer){
      let responseJson = await make_request({
        path: 'check_answer',
        method: 'POST',
        body: {
          level_id: this.state.level.id,
          answer: this.state.answer
        }
      });
      if(responseJson.status === "success") {
        alert("Level Passed! You are entring next level!!");
        this.fetch_request();
      } else {
        let recent_answers = this.state.recent_answers || [];
        // if(recent_answers.length >= 5){
        //   recent_answers.splice(0, 1);
        // }
        recent_answers.push(this.state.answer);
        this.setState({
          answer: '',
          recent_answers: recent_answers
        });
      }
    }
  }

  get_leader_board = async () => {
    let responseJson = await make_request({
      path: 'leader_board',
      method: 'GET'
    });
    this.setState({
      leader_board: responseJson,
      is_modal_open: !this.state.is_modal_open
    });
  }

  render() {
    const { level, skills, show_this_hint, recent_answers } = this.state;
    return (
      <div className="innerBody">
        <Header />
        
        <div className="container mt-2 levelpage mb-5">

              <div className="row d-flex flex-wrap">
         <div className="col-3">
            <div className="pt-2"> <img src={Group615} className="group-img" alt="" /> </div>
         </div>
         <div className="col-6" id="card">
            <div className="top-area">
               <ul className="nav navbar-nav align-content-center">
                  <li className="dropdown mt-2">
                     <a
                        href="/"
                        className="dropdown-toggle chapter-text"
                        data-toggle="dropdown"
                        >
                     Chapter 1 - level 24
                     <i className="fas fa-chevron-down ml-2"></i>
                     </a>
                     <ul className="dropdown-menu keep-open">
                        <li>
                           <Accordion>
                              <AccordionItem>
                                 <AccordionItemHeading>
                                    <AccordionItemButton>Chapter 1</AccordionItemButton>
                                 </AccordionItemHeading>
                                 <AccordionItemPanel>
                                    <Nav vertical pills>
                                       <NavItem>
                                          <NavLink href="/" active>
                                             Level 1
                                          </NavLink>
                                       </NavItem>
                                       <NavItem>
                                          <NavLink href="/">Level 2</NavLink>
                                       </NavItem>
                                       <NavItem>
                                          <NavLink href="/">Level 3</NavLink>
                                       </NavItem>
                                       <NavItem>
                                          <NavLink href="/">Level 1</NavLink>
                                       </NavItem>
                                       <NavItem>
                                          <NavLink href="/">Level 2</NavLink>
                                       </NavItem>
                                       <NavItem>
                                          <NavLink href="/">Level 3</NavLink>
                                       </NavItem>
                                    </Nav>
                                 </AccordionItemPanel>
                              </AccordionItem>
                              <AccordionItem>
                                 <AccordionItemHeading>
                                    <AccordionItemButton>Chapter 2</AccordionItemButton>
                                 </AccordionItemHeading>
                                 <AccordionItemPanel>
                                    <Nav vertical pills>
                                       <NavItem>
                                          <NavLink href="/" active>
                                             Level 1
                                          </NavLink>
                                       </NavItem>
                                       <NavItem>
                                          <NavLink href="/">Level 2</NavLink>
                                       </NavItem>
                                       <NavItem>
                                          <NavLink href="/">Level 3</NavLink>
                                       </NavItem>
                                       <NavItem>
                                          <NavLink href="/">Level 1</NavLink>
                                       </NavItem>
                                       <NavItem>
                                          <NavLink href="/">Level 2</NavLink>
                                       </NavItem>
                                       <NavItem>
                                          <NavLink href="/">Level 3</NavLink>
                                       </NavItem>
                                    </Nav>
                                 </AccordionItemPanel>
                              </AccordionItem>
                           </Accordion>
                        </li>
                     </ul>
                  </li>
               </ul>
            </div>
           
         </div>
         <div className="col-3 text-right pt-2">
            <div className="top-area">
               <a href="#?"> <img
                  src={Heart}
                  className="cart"
                  onClick={this.toggleCart}
                  alt=""
                /> <span class='badge badge-warning' id='lblCartCount'> 5 </span>  </a>
            </div>
         </div>
         <div className="col-12 text-center pt-2  buy_hint">
           
         </div>


         <div className="col-md-12 col-11 d-flex text-center pt-4 pb-4">

           <div className="pl-2 pt-2 pb-2 pr-0 flex-grow-1">
                  <Progress multi>
                    <Progress bar color="custom" value={this.state.progress_width}></Progress>
                  </Progress>
                  <div className="progress-icon d-flex">
                    {this.hint_track()}
                  </div>
                  </div>

                  <div className="col-1 text-right">
                  <div className="icon4 avatar-circle-xsm">
                      <span className="timers">
                       <Timer
              initialTime={0}
              startImmediately={true}
              direction="forward" className={''}
            >
              {() => (
                <div className="">
                <React.Fragment> 
                  <Timer.Minutes /> : <Timer.Seconds /> 
                </React.Fragment>
                </div>
              )}
            </Timer> </span>
                    </div>
                  </div>  

         </div>


         <div className="col-12">

            <div className="focus_grow">
               <div className="mt-fix-10 card shadow-0 border-0 text-white text-center">
                <div>
                  {
                    level.image &&
                    <img
                      src={level.image}
                      alt="level_image"
                      className="card-img img-scale main-image"
                    />
                  }
                  <div className="card-img-overlay d-flex align-items-center p-0">
                    {
                      show_this_hint.map(hint => {
                        return( <Hint hint={hint} /> );
                      })
                    }
                  </div>


                </div>
                
              </div>
              </div>

              <div className="card card-black mt-3 mb-5">
                <p className="mb-1">{level.description}</p>
              </div>

         </div>


         <div className="col-12">

           <div className="card recent-answers mt-3 p-3">
                <h3 className="skills-text mt-1 ml-2 text-center">recent answers</h3>
                <ul className="list-group headline mb-5" style={{overflow: "auto", maxHeight: "270px"}}>
                {
                  recent_answers && (recent_answers.length > 0) &&
                  recent_answers.map((recent_answer, index) => {
                    return(
                      <li key={index} className="list-group-item">{recent_answer}</li>
                    )
                  })
                }
                </ul>
               
          
              </div>

         </div>



         <div className="col-12">

            <div className="mt-2 mb-2">
             
              <div className="card icon-list mt-fix-5">
                {
                  (skills && (skills.length > 0)) ? (
                    <div>
                      <h3 className="skills-text mt-1 ml-2">Skills Required</h3>
                      <ul className="list-group">
                        {
                          skills.map((skill, index) => {
                            return(
                              <li key={index} className="list-group-item align-items-center p-0 mt-2">
                                <div className="media">
                                  <div className="media-left">
                                    <div className="avatar-circle-30px">
                                      <span className="initials initials-img">
                                        {
                                          skill.image &&
                                          <img
                                            className="media-object pl-1"
                                            src={skill.image}
                                            alt="skill_image"
                                          />
                                        }
                                      </span>
                                    </div>
                                  </div>
                                 
                                </div>
                              </li>
                            )
                          })
                        }
                      </ul>
                      <div className="border-top-list" />
                    </div>
                  ) : null
                }
                <div className="d-flex">
              <div className="col-6 analytic-area mt-2 mb-2">
                <h4 className="complexity-text">
                  Complexity <span className="custom-red ml-2">70/100</span>
                </h4>
                <Progress value="1" color="custom-red" max="5" />
              </div>
              <div className="col-6 analytic-area mt-2 mb-2">
                <h4 className="complexity-text">
                  Success rate <span className="custom-green ml-2">80/100</span>
                </h4>
                <Progress value="1" color="custom-green" max="5" />
              </div>
              </div>
              </div>
            </div>

         </div>





           <div className="col-12 text-center pt-2 mb-5 leader_brd">

              ​<button type="button" class="btn btn-yellow" data-toggle="collapse" data-target="#demo"> <img className="" src={ldr_brd_icon} alt="..." /> &nbsp; &nbsp; LEADERBOARD </button>
               <div id="demo" class="collapse">
     
              <table className="table  table-dark table-hover mt-3">
              <tbody>
                <tr>
                  <td>#1</td>
                  <td>James Cole</td>
                  <td>Level 320</td>
                </tr>
                <tr>
                  <td>#1</td>
                  <td>James Cole</td>
                  <td>Level 320</td>
                </tr>
                <tr>
                  <td>#1</td>
                  <td>James Cole</td>
                  <td>Level 320</td>
                </tr>
                <tr>
                  <td>#1</td>
                  <td>James Cole</td>
                  <td>Level 320</td>
                </tr>
              </tbody>
            </table>

  </div>
           </div>


         <div className="col-12">

          

         </div>

         <div className="col-12">

          

         </div>



         </div>


   
          <div className="footer-answer d-flex justify-content-center">
            <div className="">
              <div className="col-12 form-group mx-sm-3 mb-2">
                <label htmlFor="inputPassword2" className="sr-only">
                  Answer here
                </label>
                <input
                  name="answer"
                  type="text"
                  autoFocus={true}
                  className="form-control"
                  id="inputPassword2"
                  value={this.state.answer}
                  onChange={this.handle_change}
                  onKeyPress={this.enter_pressed}
                />
              </div>
              <div className="col-12 text-center">
              <button type="submit" className="btn mb-2" onClick={this.submit_answer}>
                SUBMIT
              </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default LevelPageMobile;
